/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { monitor } from '@soluto-private/mx-monitor';

const attachErrorHandler = (ele: HTMLElement) =>
    ele.addEventListener('error', (e) =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        monitor.error('Error thrown from ae-sdk', e.error)
    );

const injectScript = async (id: string, src: string): Promise<void> => {
    const existingScript = document.getElementById(id);
    if (existingScript) {
        attachErrorHandler(existingScript);
        return;
    }

    await new Promise<void>((resolve) => {
        const w = window,
            a = '__AE_SDK_ACTIONS',
            d = document,
            s = d.createElement('script', {}),
            b = d.getElementsByTagName('script')[0];

        (window as any)[a] = [];
        w.AE_SDK = function (_: any) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (window as any)[a].push(_);
        };
        s.type = 'text/javascript';
        s.async = true;
        s.src = src;
        s.style.zIndex = '2147483646';
        b.parentNode?.insertBefore(s, b.nextSibling);
        attachErrorHandler(s);
        resolve();
    });
};
export default injectScript;
